import React from 'react';
import './Modal.css'; // or create a HandMenuModal.css if separated

const HandMenuModal = ({ card, onAction, onClose }) => {
  if (!card) return null;

  let actions = [];
  
    if (card.zone?.startsWith('Opp')) {
      actions = []; // No actions for opponent card
    }

    else if (card.type.includes('Monster')) {
      actions = [
        'Reveal', 'Declare','To Bottom deck', 'To Top Deck',
        'Banish FD', 'Banish', 'To GY', 'SS DEF', 'SS ATK',
        'Set Monster Zone', 'Set S/T', 'N.Summon'
      ];

      // ✅ Add 'Activate' if it's a Pendulum monster
      if (card.type.includes('Pendulum')) {
        actions.push('Activate');
      }
    }
    else if (card.race === 'Field') {
    actions = [
        'Reveal', 'Declare', 'To Bottom deck', 'To Top Deck',
        'Banish FD', 'Banish', 'To GY', 'Set Field', 'Activate Field'
    ];
    } else {
    actions = [
        'Reveal', 'Declare', 'To Bottom deck', 'To Top Deck',
        'Banish FD', 'Banish', 'To GY', 'Set S/T', 'Activate'
    ];
    }


  return (
    <div className="modal-backdrop">
      <div className="modal-content hand-menu-modal">
        <div className="modal-left">
          <img
            onContextMenu={(e) => e.preventDefault()}
            onMouseDown={(e) => e.button === 2 && e.preventDefault()}
            onTouchStart={(e) => e.preventDefault()}
            draggable={false}
            src={card.card_images[0].image_url}
            alt={card.name}
            className="modal-card-image"
          />
            <div className="modal-card-info">
                <h3>{card.name}</h3>
                <p><strong>Card:</strong> {card.type}</p>

                {/* Monster-specific info */}
                {card.atk !== undefined && (
                    <p>
                    <strong>ATK/DEF:</strong> {card.atk} / {card.def ?? '—'}
                    </p>
                )}
                {card.level && (
                    <p>
                    <strong>Level:</strong> {card.level}
                    </p>
                )}
                {card.linkval && (
                    <p>
                    <strong>Link Rating:</strong> {card.linkval}
                    </p>
                )}

                {/* Race/Attribute */}
                {card.race && <p><strong>Type:</strong> {card.race}</p>}
                {card.attribute && <p><strong>Attribute:</strong> {card.attribute}</p>}

                {/* Effect text */}
                <p dangerouslySetInnerHTML={{ __html: card.desc.replace(/\n/g, '<br/>') }} />
            </div>

        </div>

        <div className="modal-right">
          <h3>Choose Action</h3>
          <ul className="action-list">
            {actions.map((action, index) => (
             // <li key={index} onClick={() => onAction(action)}>{action}</li>
             <li
                key={index}
                onClick={() => {
                  onAction(action, card);
                }}
              >{action}</li>

            ))}
          </ul>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default HandMenuModal;
